<template>
    <div class="map-container">
        <yandex-map
                ref="ymap"
                :bounds="mapBounds"
                :coords="coords"
                :zoom="10"
                :controls="['zoomControl']"
                :cluster-options="clusterOptions"
                @map-was-initialized="mapInit"
        >
            <ymap-marker
                    v-for="address in addresses" :key="address.uid"
                    :coords="address.coordinates"
                    :marker-id="address.uid"
                    :icon="createMarker()"
                    :balloon="{header: getHeader(address), body: getBody(address)}"
                    cluster-name="1"
                    @balloonopen="bindListener"
                    @balloonclose="unbindListener"
            />
        </yandex-map>
    </div>
</template>

<script>
    export default {
        name: "PvzMap",
        props: ['list', 'simpleMode'],
        data() {
            return {
                ymap: null,
                coords: [
                    55.751244,
                    37.618423,
                ],
                clusterOptions: {
                    1: {
                        gridSize: 60,
                        preset: "islands#invertedVioletClusterIcons",
                        clusterIcons: [
                            {
                                href: "/cloudmill/images/map.png",
                                size: [66, 66],
                                offset: [-33, -33]
                            }
                        ],
                        groupByCoordinates: false,
                        clusterIconColor: "black",
                        clusterHideIconOnBalloonOpen: false,
                        geoObjectHideIconOnBalloonOpen: false
                    },
                },
            }
        },
        computed: {
            mapBounds() {
                let minX = 1000;
                let minY = 1000;
                let maxX = 0;
                let maxY = 0;
                this.addresses.map( address => {
                    if(!address.coordinates || !address.coordinates.length){
                        return
                    }
                    this.$log('Address ->>', address.coordinate);
                    if(address.coordinates[0] < minX){
                        minX = address.coordinates[0]
                    }
                    if(address.coordinates[1] < minY){
                        minY = address.coordinates[1]
                    }
                    if(address.coordinates[0] > maxX){
                        maxX = address.coordinates[0]
                    }
                    if(address.coordinates[1] > maxY){
                        maxY = address.coordinates[1]
                    }
                })

                if(minX == 1000){
                    return [
                        [45, 45], [55, 55]
                    ]
                }

                if(minX == maxX){
                    return [
                        [minX - 0.002, minY - 0.002], [maxX + 0.002, maxY + 0.002]
                    ]
                }

                return [
                    [minX, minY], [maxX, maxY]
                ]
            },
            addresses() {
                return this.list.filter( address => {
                   return address.coordinates && address.coordinates.length
                })
            }
        },
        methods: {
            getHeader (address) {
                return '<b style="font-weight: bold;">' + address.name + '</b>';
            },
            getBody (address) {
                return '<ul style="padding-left: 0px; font-size: 80%;">' +
                    '<li><b style="font-weight: bold;">Адрес:</b> ' + address.address + '</li>' +
                    '<li><b style="font-weight: bold;">Телефон:</b> ' + address.phone + '</li>' +
                    (address.email ? '<li><b style="font-weight: bold;">E-mail:</b> ' + address.email + '</li>' : '') +
                    '<li>' + (address.info || '') + '</li>' +
                    ( !this.simpleMode ? '<li><a  href="javascript:void(0)" address-id="' + address.uid + '" id="addressClick">выбрать этот пункт</a></li>' : '') +
                    '</ul>';
            },
            createMarker () {
                return{
                    layout: 'default#imageWithContent',
                    imageHref: '/cloudmill/images/map.png',
                    imageSize: [66, 66],
                    imageOffset: [-33, -33],
                }
            },
            mapInit (payload) {
                this.ymap = payload;
                this.$log('maps', this.ymap.geoObjects.removeAll())
            },
            bindListener() {
                if(document.getElementById('addressClick')){
                    document.getElementById('addressClick').addEventListener('click', this.selectAddress);
                }
            },
            unbindListener() {
                if(document.getElementById('addressClick')){
                    document.getElementById('addressClick').removeEventListener('click', this.selectAddress);
                }
            },
            selectAddress(event) {
                const id = window.$(event.target).attr('address-id');
                const selectedAddress = this.list.filter( address => address.uid == id )
                this.$emit('select-pvz', selectedAddress[0])
            },
        }
    }
</script>

<style scoped>
    .map-container {
        width: 100%;
        height: 400px;
        border: 1px solid #d0d0d0;
    }
</style>